module.exports = __webpack_public_path__ + "static/media/thropy.4332e6a2.svg";